<a routerLink="/blog/{{data.apelido_categoria}}/{{data.apelido}}">
      <div class="blog-item-two">
          <div class="capa">
              <img [src]="data.imagem" width="100%" />
          </div>
          <div class="content">
              <h4>{{data.titulo}}</h4>
          </div>    
      </div> 
</a>   